var _circle, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDataNotLinkedToYou(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 33,
    viewBox: "0 0 31 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 10.5,
    r: 4.5,
    fill: "#3478F6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 24.5C24 22.2457 23.1045 20.0837 21.5104 18.4896C19.9163 16.8955 17.7543 16 15.5 16C13.2457 16 11.0837 16.8955 9.48959 18.4896C7.89553 20.0837 7 22.2457 7 24.5L15.5 24.5H24Z",
    fill: "#3478F6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 3L28 28.5",
    stroke: "white",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.08782 8.5C1.76273 10.6883 1 13.2551 1 16C1 24.0081 7.49187 30.5 15.5 30.5C18.2449 30.5 20.8117 29.7373 23 28.4122M8 3.58782C10.1883 2.26273 12.7551 1.5 15.5 1.5C23.5081 1.5 30 7.99187 30 16C30 18.7449 29.2373 21.3117 27.9122 23.5M2.5 3L27.9122 28.4122",
    stroke: "#3478F6",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataNotLinkedToYou);
export default __webpack_public_path__ + "static/media/data-not-linked-to-you.a05e437962ccb9ff648f2771c90d6935.svg";
export { ForwardRef as ReactComponent };